// /* eslint-disable no-shadow */
// /* eslint-disable */
// import React, { Component } from 'react';
// import { Layout, Row, Col, message } from 'antd'; // ,Button
// import FeatherIcon from 'feather-icons-react';
// import { Link } from 'react-router-dom';
// import { Scrollbars } from 'react-custom-scrollbars';
// import { ThemeProvider } from 'styled-components';
// import { connect } from 'react-redux';
// import propTypes from 'prop-types';
// import MenueItems from './MenueItems';
// // import TopMenu from './TopMenu';
// import { Div, TopMenuSearch, SmallScreenSearch, SmallScreenAuthInfo } from './style';
// import { setChatCall } from '../redux/CrmReduxCalls/EditNavCtrl';
// import { NotesIcon } from '../components/Icons/Icons';
// import { Card } from '../components/note/style'; // Bullet
// import { Cards } from '../components/cards/frame/cards-frame';
// import NotesPopup from '../container/dashboard/Popup/NotesPopup'
// import ChatBot from '../container/dashboard/Pages/GlobalComponents/ChatBot'
// import HeaderSearch from '../components/header-search/header-search';
// import AuthInfo from '../components/utilities/auth-info/info';
// import ConfirmationPopup from '../container/dashboard/Popup/ConfirmationPopup'
// import CustomHtmlParser from '../container/dashboard/Email/CustomHtmlParser'
// import { UserNotes, deleteNoteId } from '../Api/Services/NotesapiServices';

// const { darkTheme } = require('../config/theme/themeVariables');

// const { Header, Footer, Sider, Content } = Layout;
// // const { darkMode } = config;

// const ThemeLayout = (WrappedComponent) => {
//   class LayoutComponent extends Component {
//     constructor(props) {
//       super(props);
//       this.state = {
//         collapsed: false,
//         hide: true,
//         searchHide: true,
//         activeSearch: false,
//         // customizerAction: false,
//         notePopup: false,
//         popupType: undefined,
//         notes: undefined,
//         noteId: undefined,
//         page: "",
//         confirmPopup: false,
//         deleteId: undefined,
//         // image: null,
//         // role: null,
//       };
//       this.updateDimensions = this.updateDimensions.bind(this);
//       this.handleNoteClick = this.handleNoteClick.bind(this);
//       this.closePopup = this.closePopup.bind(this);
//       this.OnClickofDelete = this.OnClickofDelete.bind(this);
//       this.onclickDelectclose = this.onclickDelectclose.bind(this);
//     }

//     componentDidMount() {
//       window.addEventListener('resize', this.updateDimensions);
//       this.updateDimensions();
//       this.getAllNotes();
//       // this.getProfile();
//     }

//     componentWillUnmount() {
//       window.removeEventListener('resize', this.updateDimensions);
//     }

//     handleNoteClick = (value, id) => {
//       const isMobile = window.innerWidth <= 768;
//       this.setState({
//         notePopup: true,
//         popupType: value,
//         noteId: id,
//         page: "Global",
//         // Close the notes panel on mobile so the modal has full focus
//         ...(isMobile && { customizerAction: false }),
//       });
//     };

//     onclickDelectclose() {
//       this.setState({
//         confirmPopup: false,
//         deleteId: undefined,
//       });
//     }

//     OnClickofDelete = (value) => {
//       this.setState({
//         confirmPopup: true,
//         deleteId: value,
//       });
//     }

//     getAllNotes = async () => {
//       try {
//         const response = await UserNotes()
//         const reversedNotes = response.slice().reverse();
//         const personalNotes = reversedNotes.filter(note => note.relatedTo === "Personal");
//         this.setState({
//           notes: personalNotes,
//         });
//       } catch (error) {
//         message.error(error);
//       }
//     };

//     handleDelete = async (id) => {
//       try {
//         const response = await deleteNoteId(id);
//         if (response.status === 200) {
//           message.success("Note deleted")
//           this.getAllNotes()
//           this.closePopup()
//         }
//       }
//       catch (error) {
//         message.error(error)
//       }
//     }

//     closePopup() {
//       const isMobile = window.innerWidth <= 768;
//       this.setState({
//         notePopup: false,
//         popupType: undefined,
//         noteId: undefined,
//         page: "",
//         // Re-open the notes panel on mobile after modal closes
//         ...(isMobile && { customizerAction: true }),
//       });
//     }

//     updateDimensions() {
//       this.setState({
//         collapsed: window.innerWidth <= 1200 && false,
//         // collapsed: window.innerWidth <= 1200 && true,
//       });
//     }

//     render() {
//       const urlSearch = window.location.search;
//       const UrlId = urlSearch.split('=');
//       const currentYear = new Date().getFullYear();
//       const { collapsed, hide, searchHide, activeSearch, customizerAction, notePopup, popupType, notes, noteId, page, confirmPopup, deleteId } = this.state; // , image, role
//       const { ChangeLayoutMode, rtl, topMenu } = this.props; //  changeRtl, changeLayout, changeMenuMode 
//       const left = !rtl ? 'left' : 'right';
//       const darkMode = ChangeLayoutMode;
//       // const toggleCollapsed = () => {
//       //   this.setState({
//       //     collapsed: !collapsed,
//       //   });
//       // };
//       const toggleCollapsedMobile = () => {
//         if (window.innerWidth <= 768) {
//           this.setState({
//             collapsed: !collapsed,
//           });
//         }
//       };
//       const showCustomizer = () => {
//         const { storeSubcription } = this.props;
//         if (storeSubcription?.isActive) {
//           this.setState({
//             customizerAction: !customizerAction,
//           });
//         }
//         else {
//           message.info("Your subscription is not active. Please renew to continue");
//         }
//       };
//       const showGenie = () => {
//         const { genieChat, setChatCall, storeSubcription } = this.props;
//         if (storeSubcription?.isActive) {
//           setChatCall(!genieChat);
//         }
//         else {
//           message.info("Your subscription is not active. Please renew to continue");
//         }
//       }
//       const onShowHide = () => {
//         this.setState({
//           hide: !hide,
//           searchHide: true,
//         });
//       };
//       const toggleSearch = () => {
//         this.setState({
//           activeSearch: !activeSearch,
//         });
//       };
//       // const handleSearchHide = (e) => {
//       //   e.preventDefault();
//       //   this.setState({
//       //     searchHide: !searchHide,
//       //     hide: true,
//       //   });
//       // };
//       const footerStyle = {
//         padding: '20px 30px 18px',
//         color: 'rgba(0, 0, 0, 0.65)',
//         fontSize: '14px',
//         background: 'rgba(255, 255, 255, .90)',
//         width: '100%',
//         // boxShadow: '0 -5px 10px rgba(146,153,184, 0.05)',
//         boxShadow: '#0000002d 0px -2px 5px',
//       };
//       const isMobile = window.innerWidth <= 768;
//       const SideBarStyle = {
//         margin: isMobile ? '0' : '63px 0 0 0',
//         padding: '15px 15px 55px 15px',
//         overflowY: 'auto',
//         height: '100vh',
//         position: 'fixed',
//         ...(isMobile ? { right: 0, left: 'auto' } : { [left]: 0 }),
//         zIndex: isMobile ? 1050 : 998,
//       };
//       const renderView = ({ style, ...props }) => {
//         const customStyle = {
//           marginRight: 'auto',
//           [rtl ? 'marginLeft' : 'marginRight']: '-17px',
//         };
//         return <div {...props} style={{ ...style, ...customStyle }} />;
//       };
//       const renderThumbVertical = ({ style, ...props }) => {
//         const { ChangeLayoutMode } = this.props;
//         const thumbStyle = {
//           borderRadius: 6,
//           backgroundColor: ChangeLayoutMode ? '#ffffff16' : '#F1F2F6',
//           [left]: '2px',
//         };
//         return <div style={{ ...style, ...thumbStyle }} {...props} />;
//       };
//       const renderTrackVertical = () => {
//         const thumbStyle = {
//           position: 'absolute',
//           width: '6px',
//           transition: 'opacity 200ms ease 0s',
//           opacity: 0,
//           [rtl ? 'left' : 'right']: '2px',
//           bottom: '2px',
//           top: '2px',
//           borderRadius: '3px',
//         };
//         return <div style={thumbStyle} />;
//       };
//       const renderThumbHorizontal = ({ style, ...props }) => {
//         const { ChangeLayoutMode } = this.props;
//         const thumbStyle = {
//           borderRadius: 6,
//           backgroundColor: ChangeLayoutMode ? '#ffffff16' : '#F1F2F6',
//         };
//         return <div style={{ ...style, ...thumbStyle }} {...props} />;
//       };
//       // const onRtlChange = () => {
//       //   const html = document.querySelector('html');
//       //   html.setAttribute('dir', 'rtl');
//       //   changeRtl(true);
//       // };
//       // const onLtrChange = () => {
//       //   const html = document.querySelector('html');
//       //   html.setAttribute('dir', 'ltr');
//       //   changeRtl(false);
//       // };
//       // const modeChangeDark = () => {
//       //   changeLayout(true);
//       // };
//       // const modeChangeLight = () => {
//       //   changeLayout(false);
//       // };
//       // const modeChangeTopNav = () => {
//       //   changeMenuMode(true);
//       // };
//       // const modeChangeSideNav = () => {
//       //   changeMenuMode(false);
//       // };
//       // const onEventChange = {
//       //   onRtlChange,
//       //   onLtrChange,
//       //   modeChangeDark,
//       //   modeChangeLight,
//       //   modeChangeTopNav,
//       //   modeChangeSideNav,
//       // };

//       return (
//         <Div darkMode={!darkMode}>
//           {/* <Div darkMode={darkMode}></Div> */}
//           <Layout className="layout" >
//             <Header
//               style={{
//                 position: 'fixed',
//                 width: '100%',
//                 top: 0,
//                 [!rtl ? 'left' : 'right']: 0,
//               }}
//             >
//               <Row className="mobile-header-row">
//                 <Col
//                   lg={!topMenu ? 4 : 3}
//                   sm={6} xs={12}
//                   className="align-center-v navbar-brand" style={{ display: "flex", alignItems: "center", justifyContent: "flex-start" }}>
//                   {!topMenu || window.innerWidth <= 991 ? (
//                     <>
//                       {/* <Button type="link" onClick={toggleCollapsed}>
//                         <img src={require(`../static/img/icon/${collapsed ? 'right.svg' : 'left.svg'}`)} alt="menu" className="img-margin" />
//                       </Button> */}
//                     </>
//                   ) : null}
//                   <Link
//                     className={topMenu && window.innerWidth > 991 ? 'striking-logo top-menu' : 'striking-logo'}
//                     to="#"
//                   >
//                     {/* <div
//                       style={{
//                         display: "flex",
//                         alignItems: "center",
//                         gap: "12px",
//                         flexWrap: "wrap"
//                       }}
//                     > */}
//                     <img className="company-logo"
//                       src={
//                         !darkMode
//                           ? require('../static/img/Logo/Logo.png')
//                           : require('../static/img/Logo/Logo.png')
//                       }
//                       alt="Company Logo"
//                     />
//                     {/* {role !== "Super Admin" && (
//                         <>
//                           <div
//                             className="vertical-line"
//                           />
//                           <img className='account-image'
//                             src={image || require('../static/img/defaultlogo.png')}
//                             alt="Account Logo"
//                           />
//                         </>
//                       )}
//                     </div> */}
//                   </Link>

//                 </Col>

//                 <Col lg={!topMenu ? 14 : 15} md={8} sm={0} xs={0}>
//                   {/* {topMenu && window.innerWidth > 991 ? <TopMenu /> : <HeaderSearch rtl={rtl} darkMode={darkMode} />} */}
//                 </Col>

//                 <Col lg={6} md={10} sm={0} xs={0}>
//                   {topMenu
//                     // && window.innerWidth > 991 
//                     ? (
//                       <TopMenuSearch>
//                         <div className="top-right-wrap d-flex">
//                           <Link
//                             className={`${activeSearch ? 'search-toggle active' : 'search-toggle'}`}
//                             onClick={() => {
//                               toggleSearch();
//                             }}
//                             to="#"
//                           >
//                             <FeatherIcon icon="search" />
//                             <FeatherIcon icon="x" />
//                           </Link>
//                           <div className={`${activeSearch ? 'topMenu-search-form show' : 'topMenu-search-form'}`}>
//                             <form action="">
//                               <span className="search-icon">
//                                 <FeatherIcon icon="search" />
//                               </span>
//                               <input type="text" name="search" />
//                             </form>
//                           </div>
//                           <AuthInfo />
//                         </div>
//                       </TopMenuSearch>
//                     ) : (
//                       <AuthInfo />
//                     )}
//                 </Col>

//                 <Col md={0} sm={18} xs={12} >
//                   <div className="mobile-action" style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }}>
//                     {/* Hamburger toggle for mobile sidebar */}
//                     <span
//                       className="mobile-sidebar-toggle"
//                       role="button"
//                       tabIndex={0}
//                       aria-label="Toggle sidebar"
//                       onClick={toggleCollapsedMobile}
//                       onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') toggleCollapsedMobile(); }}
//                     >
//                       <FeatherIcon icon={collapsed ? 'x' : 'menu'} size={22} />
//                     </span>
//                     <Link className="btn-auth" onClick={onShowHide} to="#">
//                       <FeatherIcon icon="more-vertical" />
//                     </Link>
//                   </div>
//                 </Col>
//               </Row>
//             </Header>
//             <div className="header-more">
//               <Row>
//                 <Col md={0} sm={24} xs={24}>
//                   <div className="small-screen-headerRight">
//                     <SmallScreenSearch hide={searchHide} darkMode={darkMode}>
//                       <HeaderSearch rtl={rtl} />
//                     </SmallScreenSearch>
//                     <SmallScreenAuthInfo hide={hide} darkMode={darkMode}>
//                       <AuthInfo rtl={rtl} />
//                     </SmallScreenAuthInfo>
//                   </div>
//                 </Col>
//               </Row>
//             </div>
//             <Layout>
//               {/* Mobile backdrop overlay */}
//               {collapsed && window.innerWidth <= 768 && (
//                 <div
//                   onClick={toggleCollapsedMobile}
//                   style={{
//                     position: 'fixed', top: 64, left: 0,
//                     width: '100vw', height: 'calc(100vh - 64px)',
//                     background: 'rgba(0,0,0,0.45)',
//                     zIndex: 1049,
//                   }}
//                 />
//               )}
//               {!topMenu
//                 // || window.innerWidth <= 991 
//                 ? (
//                   <ThemeProvider theme={darkTheme}>
//                     <Sider width={280} style={SideBarStyle} collapsed={!collapsed} theme={darkMode ? 'light' : 'dark'}>
//                       {/* <Sider width={280} style={SideBarStyle} collapsed={collapsed} theme={!darkMode ? 'light' : 'dark'}> */}
//                       <Scrollbars
//                         className="custom-scrollbar"
//                         autoHide
//                         autoHideTimeout={500}
//                         autoHideDuration={200}
//                         renderThumbHorizontal={renderThumbHorizontal}
//                         renderThumbVertical={renderThumbVertical}
//                         renderView={renderView}
//                         renderTrackVertical={renderTrackVertical}
//                       >
//                         {/* Close button - mobile only */}
//                         {/* <div className="sidebar-mobile-close" role="button" tabIndex={0}
//                           onClick={toggleCollapsedMobile}
//                           onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') toggleCollapsedMobile(); }}
//                           aria-label="Close sidebar"
//                         >
//                           <FeatherIcon icon="x" size={20} />
//                         </div> */}
//                         <p className="sidebar-nav-title">MAIN MENU</p>
//                         <MenueItems
//                           topMenu={topMenu}
//                           rtl={rtl}
//                           toggleCollapsed={toggleCollapsedMobile}
//                           darkMode={!darkMode}
//                         // darkMode={darkMode}
//                         />
//                       </Scrollbars>
//                     </Sider>
//                   </ThemeProvider>
//                 ) : null}
//               <Layout className="atbd-main-layout">
//                 <Content>
//                   <WrappedComponent {...this.props} />
//                   {/* <Footer className="admin-footer" style={footerStyle}>
//                     <Row>
//                       <Col md={12} xs={24}>
//                         <a href="https://cxsquare.solutions/" className="admin-footer__link" target="_blank" rel="noopener noreferrer">
//                           <span className="admin-footer__copyright">Powered by CXSquare Solutions @ {currentYear}</span>
//                         </a>
//                       </Col>
//                     </Row>
//                   </Footer> */}
//                 </Content>
//               </Layout>
//             </Layout>
//           </Layout >
//           <div className="floating-actions">
//             <div style={{ cursor: "pointer" }} tabIndex={0} role="button"
//               onKeyDown={(e) => {
//                 if (e.key === 'Enter' || e.key === ' ') {
//                   showCustomizer();
//                   this.getAllNotes();
//                 }
//               }}
//               className="customizer-trigger notes-trigger"
//               onClick={() => {
//                 showCustomizer();
//                 this.getAllNotes();
//               }}
//             >
//               <NotesIcon />
//             </div>
//             <div style={{ cursor: "pointer" }} tabIndex={0} role="button"
//               onKeyDown={(e) => {
//                 if (e.key === 'Enter' || e.key === ' ') {
//                   showGenie();
//                 }
//               }}
//               className="customizer-trigger1 genie-trigger"
//               onClick={() => {
//                 showGenie();
//               }}
//             >
//               <img src={require('../static/img/defaultImages/Genie.png')} alt="Genie" className="genie-icon" style={{ padding: 2 }} />
//             </div>
//           </div>
//           <div className={`${customizerAction ? 'customizer-wrapper show' : 'customizer-wrapper'}`}>
//             <div className="customizer">
//               <div className="customizer__head">
//                 <h4 className="customizer__title">Personal Notes</h4>
//                 <span className="customizer__sub-title">Leave Your Notes Here...</span>
//                 <div style={{ cursor: "pointer" }} tabIndex={0} role="button"
//                   onKeyDown={(e) => {
//                     if (e.key === 'Enter' || e.key === ' ') {
//                       showCustomizer();
//                     }
//                   }}
//                   className="customizer-close"
//                   onClick={() => {
//                     showCustomizer();
//                   }}
//                 >
//                   <FeatherIcon icon="x" />
//                 </div>
//               </div>
//               <div className="customizer__body">
//                 <div className="customizer__single">
//                   {/* <h4>Layout Type</h4> */}
//                   <div style={{ cursor: "pointer", color: '#40a9ff' }} tabIndex={0} role="button"
//                     onKeyDown={(e) => {
//                       if (e.key === 'Enter' || e.key === ' ') {
//                         this.handleNoteClick("Create");
//                       }
//                     }}
//                     className="text_icon"
//                     onClick={() => {
//                       this.handleNoteClick("Create");
//                     }}
//                   >
//                     <FeatherIcon icon="plus" size={17} className="text_iconspace" /> Notes
//                   </div>
//                   {confirmPopup && <ConfirmationPopup confirmPopup={confirmPopup} setConfirmPopup={this.onclickDelectclose} GetCallback={this.handleDelete} deleteId={deleteId} page="Notes" />}
//                   {notePopup && <NotesPopup setNotePopup={this.closePopup} notePopup={notePopup} popupType={popupType} UrlId={UrlId} AllNotes={this.getAllNotes} noteValue={noteId} page={page} />}
//                   <ul className="customizer-list" style={{ marginTop: 10 }}>
//                     {notes && notes.map((data) => (
//                       <li key={data.note_id} className="customizer-list__item" style={{ width: "100%" }}>
//                         <Card className={data.relatedTo}>
//                           <Cards headless>
//                             <h4>
//                               <span style={{ marginTop: 0 }}>
//                                 {data.note_title}
//                                 <span className={`status-bullet ${data.relatedTo}`} />
//                               </span>
//                             </h4>
//                             <p >{data.note_desc && data.note_desc !== "" ? <CustomHtmlParser html={data.note_desc} key={data.note_id} page="Previewss" /> : "Note Description"}</p>
//                             <div className="actions">
//                               <div style={{ display: "flex", gap: 10 }}>
//                                 <span >
//                                   <div
//                                     onClick={() => { this.OnClickofDelete(data.note_id) }}
//                                     tabIndex={0} role="button" className="fetcherDelete-Icon"
//                                     onKeyDown={(e) => {
//                                       if (e.key === 'Enter' || e.key === ' ') {
//                                         this.OnClickofDelete(data.note_id)
//                                       }
//                                     }}>
//                                     <FeatherIcon icon="trash-2" size={16} />
//                                   </div>
//                                 </span>
//                                 <span style={{ marginLeft: 10 }}>
//                                   <div
//                                     onClick={() => { this.handleNoteClick("Update", data.note_id) }}
//                                     className='fetcherEdit-Icon' tabIndex={0} role="button"
//                                     onKeyDown={(e) => {
//                                       if (e.key === 'Enter' || e.key === ' ') {
//                                         this.handleNoteClick("Update", data.note_id)
//                                       }
//                                     }}>
//                                     <FeatherIcon icon="edit" size={16} />
//                                   </div>
//                                 </span></div>
//                               <div />
//                             </div>
//                           </Cards>
//                         </Card>
//                       </li>
//                     ))}
//                   </ul>
//                 </div>
//               </div>
//             </div>
//           </div>
//           <ChatBot />
//         </Div >
//       );
//     }
//   }
//   const mapStateToProps = (state) => {
//     return {
//       ChangeLayoutMode: state.ChangeLayoutMode.data,
//       rtl: state.ChangeLayoutMode.rtlData,
//       topMenu: state.ChangeLayoutMode.topMenu,
//       genieChat: state.chatRedux.chatBot,
//       storeSubcription: state.localRedux.subcription
//     };
//   };
//   const mapDispatchToProps = {
//     setChatCall,
//   };
//   LayoutComponent.propTypes = {
//     ChangeLayoutMode: propTypes.bool,
//     rtl: propTypes.bool,
//     topMenu: propTypes.bool,
//     changeRtl: propTypes.func,
//     changeLayout: propTypes.func,
//     changeMenuMode: propTypes.func,
//     genieChat: propTypes.bool,
//     storeSubcription: propTypes.object,
//     setChatCall: propTypes.func.isRequired,
//   };

//   return connect(mapStateToProps, mapDispatchToProps)(LayoutComponent);
// };
// export default ThemeLayout;

/* eslint-disable no-shadow */
/* eslint-disable */
import React, { Component } from 'react';
import { Layout, Row, Col, message } from 'antd'; // ,Button
import FeatherIcon from 'feather-icons-react';
import { Link } from 'react-router-dom';
import { Scrollbars } from 'react-custom-scrollbars';
import { ThemeProvider } from 'styled-components';
import { connect } from 'react-redux';
import propTypes from 'prop-types';
import MenueItems from './MenueItems';
// import TopMenu from './TopMenu';
import { Div, TopMenuSearch, SmallScreenSearch, SmallScreenAuthInfo } from './style';
import { setChatCall } from '../redux/CrmReduxCalls/EditNavCtrl';
import { NotesIcon } from '../components/Icons/Icons';
import { Card } from '../components/note/style'; // Bullet
import { Cards } from '../components/cards/frame/cards-frame';
import NotesPopup from '../container/dashboard/Popup/NotesPopup'
import ChatBot from '../container/dashboard/Pages/GlobalComponents/ChatBot'
import HeaderSearch from '../components/header-search/header-search';
import AuthInfo from '../components/utilities/auth-info/info';
import ConfirmationPopup from '../container/dashboard/Popup/ConfirmationPopup'
import CustomHtmlParser from '../container/dashboard/Email/CustomHtmlParser'
import { UserNotes, deleteNoteId } from '../Api/Services/NotesapiServices';
import { blockRestrictedClick, selectPlan } from '../components/utilities/utilities';

const { darkTheme } = require('../config/theme/themeVariables');

const { Header, Footer, Sider, Content } = Layout;
// const { darkMode } = config;

const ThemeLayout = (WrappedComponent) => {
  class LayoutComponent extends Component {
    constructor(props) {
      super(props);
      this.state = {
        collapsed: false,
        hide: true,
        searchHide: true,
        activeSearch: false,
        // customizerAction: false,
        notePopup: false,
        popupType: undefined,
        notes: undefined,
        noteId: undefined,
        page: "",
        confirmPopup: false,
        deleteId: undefined,
        // image: null,
        // role: null,
      };
      this.updateDimensions = this.updateDimensions.bind(this);
      this.handleNoteClick = this.handleNoteClick.bind(this);
      this.closePopup = this.closePopup.bind(this);
      this.OnClickofDelete = this.OnClickofDelete.bind(this);
      this.onclickDelectclose = this.onclickDelectclose.bind(this);
    }

    componentDidMount() {
      window.addEventListener('resize', this.updateDimensions);
      this.updateDimensions();
      this.getAllNotes();
      // this.getProfile();
    }

    componentWillUnmount() {
      window.removeEventListener('resize', this.updateDimensions);
    }

    handleNoteClick = (value, id) => {
      const isMobile = window.innerWidth <= 768;
      this.setState({
        notePopup: true,
        popupType: value,
        noteId: id,
        page: "Global",
        // Close the notes panel on mobile so the modal has full focus
        ...(isMobile && { customizerAction: false }),
      });
    };

    onclickDelectclose() {
      this.setState({
        confirmPopup: false,
        deleteId: undefined,
      });
    }

    OnClickofDelete = (value) => {
      this.setState({
        confirmPopup: true,
        deleteId: value,
      });
    }

    getAllNotes = async () => {
      try {
        const response = await UserNotes()
        const reversedNotes = response.slice().reverse();
        const personalNotes = reversedNotes.filter(note => note.relatedTo === "Personal");
        this.setState({
          notes: personalNotes,
        });
      } catch (error) {
        message.error(error);
      }
    };

    handleDelete = async (id) => {
      try {
        const response = await deleteNoteId(id);
        if (response.status === 200) {
          message.success("Note deleted")
          this.getAllNotes()
          this.closePopup()
        }
      }
      catch (error) {
        message.error(error)
      }
    }

    closePopup() {
      const isMobile = window.innerWidth <= 768;
      this.setState({
        notePopup: false,
        popupType: undefined,
        noteId: undefined,
        page: "",
        // Re-open the notes panel on mobile after modal closes
        ...(isMobile && { customizerAction: true }),
      });
    }

    updateDimensions() {
      this.setState({
        collapsed: window.innerWidth <= 1200 && false,
        // collapsed: window.innerWidth <= 1200 && true,
      });
    }

    render() {
      const urlSearch = window.location.search;
      const UrlId = urlSearch.split('=');
      const currentYear = new Date().getFullYear();
      const { collapsed, hide, searchHide, activeSearch, customizerAction, notePopup, popupType, notes, noteId, page, confirmPopup, deleteId } = this.state; // , image, role
      const { ChangeLayoutMode, rtl, topMenu, plan } = this.props; //  changeRtl, changeLayout, changeMenuMode 
      const left = !rtl ? 'left' : 'right';
      const darkMode = ChangeLayoutMode;
      // const toggleCollapsed = () => {
      //   this.setState({
      //     collapsed: !collapsed,
      //   });
      // };
      const toggleCollapsedMobile = () => {
        if (window.innerWidth <= 768) {
          this.setState({
            collapsed: !collapsed,
          });
        }
      };
      const showCustomizer = () => {
        const { storeSubcription } = this.props;
        if (storeSubcription?.isActive) {
          this.setState({
            customizerAction: !customizerAction,
          });
        }
        else {
          message.info("Your subscription is not active. Please renew to continue");
        }
      };
      const showGenie = () => {
        const { genieChat, setChatCall, storeSubcription } = this.props;
        if (storeSubcription?.isActive) {
          setChatCall(!genieChat);
        }
        else {
          message.info("Your subscription is not active. Please renew to continue");
        }
      }
      const onShowHide = () => {
        this.setState({
          hide: !hide,
          searchHide: true,
        });
      };
      const toggleSearch = () => {
        this.setState({
          activeSearch: !activeSearch,
        });
      };
      // const handleSearchHide = (e) => {
      //   e.preventDefault();
      //   this.setState({
      //     searchHide: !searchHide,
      //     hide: true,
      //   });
      // };
      const footerStyle = {
        padding: '20px 30px 18px',
        color: 'rgba(0, 0, 0, 0.65)',
        fontSize: '14px',
        background: 'rgba(255, 255, 255, .90)',
        width: '100%',
        // boxShadow: '0 -5px 10px rgba(146,153,184, 0.05)',
        boxShadow: '#0000002d 0px -2px 5px',
      };
      const isMobile = window.innerWidth <= 768;
      const SideBarStyle = {
        margin: isMobile ? '0' : '63px 0 0 0',
        padding: '15px 15px 55px 15px',
        overflowY: 'auto',
        height: '100vh',
        position: 'fixed',
        ...(isMobile ? { right: 0, left: 'auto' } : { [left]: 0 }),
        zIndex: isMobile ? 1050 : 998,
      };
      const renderView = ({ style, ...props }) => {
        const customStyle = {
          marginRight: 'auto',
          [rtl ? 'marginLeft' : 'marginRight']: '-17px',
        };
        return <div {...props} style={{ ...style, ...customStyle }} />;
      };
      const renderThumbVertical = ({ style, ...props }) => {
        const { ChangeLayoutMode } = this.props;
        const thumbStyle = {
          borderRadius: 6,
          backgroundColor: ChangeLayoutMode ? '#ffffff16' : '#F1F2F6',
          [left]: '2px',
        };
        return <div style={{ ...style, ...thumbStyle }} {...props} />;
      };
      const renderTrackVertical = () => {
        const thumbStyle = {
          position: 'absolute',
          width: '6px',
          transition: 'opacity 200ms ease 0s',
          opacity: 0,
          [rtl ? 'left' : 'right']: '2px',
          bottom: '2px',
          top: '2px',
          borderRadius: '3px',
        };
        return <div style={thumbStyle} />;
      };
      const renderThumbHorizontal = ({ style, ...props }) => {
        const { ChangeLayoutMode } = this.props;
        const thumbStyle = {
          borderRadius: 6,
          backgroundColor: ChangeLayoutMode ? '#ffffff16' : '#F1F2F6',
        };
        return <div style={{ ...style, ...thumbStyle }} {...props} />;
      };
      // const onRtlChange = () => {
      //   const html = document.querySelector('html');
      //   html.setAttribute('dir', 'rtl');
      //   changeRtl(true);
      // };
      // const onLtrChange = () => {
      //   const html = document.querySelector('html');
      //   html.setAttribute('dir', 'ltr');
      //   changeRtl(false);
      // };
      // const modeChangeDark = () => {
      //   changeLayout(true);
      // };
      // const modeChangeLight = () => {
      //   changeLayout(false);
      // };
      // const modeChangeTopNav = () => {
      //   changeMenuMode(true);
      // };
      // const modeChangeSideNav = () => {
      //   changeMenuMode(false);
      // };
      // const onEventChange = {
      //   onRtlChange,
      //   onLtrChange,
      //   modeChangeDark,
      //   modeChangeLight,
      //   modeChangeTopNav,
      //   modeChangeSideNav,
      // };

      return (
        <Div darkMode={!darkMode}>
          {/* <Div darkMode={darkMode}></Div> */}
          <Layout className="layout" >
            <Header
              style={{
                position: 'fixed',
                width: '100%',
                top: 0,
                [!rtl ? 'left' : 'right']: 0,
              }}
            >
              <Row className="mobile-header-row">
                <Col
                  lg={!topMenu ? 4 : 3}
                  sm={6} xs={12}
                  className="align-center-v navbar-brand" style={{ display: "flex", alignItems: "center", justifyContent: "flex-start" }}>
                  {!topMenu || window.innerWidth <= 991 ? (
                    <>
                      {/* <Button type="link" onClick={toggleCollapsed}>
                        <img src={require(`../static/img/icon/${collapsed ? 'right.svg' : 'left.svg'}`)} alt="menu" className="img-margin" />
                      </Button> */}
                    </>
                  ) : null}
                  <Link
                    className={topMenu && window.innerWidth > 991 ? 'striking-logo top-menu' : 'striking-logo'}
                    to="#"
                  >
                    {/* <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "12px",
                        flexWrap: "wrap"
                      }}
                    > */}
                    <img className="company-logo"
                      src={
                        !darkMode
                          ? require('../static/img/Logo/Logo.png')
                          : require('../static/img/Logo/Logo.png')
                      }
                      alt="Company Logo"
                    />
                    {/* {role !== "Super Admin" && (
                        <>
                          <div
                            className="vertical-line"
                          />
                          <img className='account-image'
                            src={image || require('../static/img/defaultlogo.png')}
                            alt="Account Logo"
                          />
                        </>
                      )}
                    </div> */}
                  </Link>

                </Col>

                <Col lg={!topMenu ? 14 : 15} md={8} sm={0} xs={0}>
                  {/* {topMenu && window.innerWidth > 991 ? <TopMenu /> : <HeaderSearch rtl={rtl} darkMode={darkMode} />} */}
                </Col>

                <Col lg={6} md={10} sm={0} xs={0}>
                  {topMenu
                    // && window.innerWidth > 991 
                    ? (
                      <TopMenuSearch>
                        <div className="top-right-wrap d-flex">
                          <Link
                            className={`${activeSearch ? 'search-toggle active' : 'search-toggle'}`}
                            onClick={() => {
                              toggleSearch();
                            }}
                            to="#"
                          >
                            <FeatherIcon icon="search" />
                            <FeatherIcon icon="x" />
                          </Link>
                          <div className={`${activeSearch ? 'topMenu-search-form show' : 'topMenu-search-form'}`}>
                            <form action="">
                              <span className="search-icon">
                                <FeatherIcon icon="search" />
                              </span>
                              <input type="text" name="search" />
                            </form>
                          </div>
                          <AuthInfo />
                        </div>
                      </TopMenuSearch>
                    ) : (
                      <AuthInfo />
                    )}
                </Col>

                <Col md={0} sm={18} xs={12} >
                  <div className="mobile-action" style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }}>
                    {/* Hamburger toggle for mobile sidebar */}
                    <span
                      className="mobile-sidebar-toggle"
                      role="button"
                      tabIndex={0}
                      aria-label="Toggle sidebar"
                      onClick={toggleCollapsedMobile}
                      onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') toggleCollapsedMobile(); }}
                    >
                      <FeatherIcon icon={collapsed ? 'x' : 'menu'} size={22} />
                    </span>
                    <Link className="btn-auth" onClick={onShowHide} to="#">
                      <FeatherIcon icon="more-vertical" />
                    </Link>
                  </div>
                </Col>
              </Row>
            </Header>
            <div className="header-more">
              <Row>
                <Col md={0} sm={24} xs={24}>
                  <div className="small-screen-headerRight">
                    <SmallScreenSearch hide={searchHide} darkMode={darkMode}>
                      <HeaderSearch rtl={rtl} />
                    </SmallScreenSearch>
                    <SmallScreenAuthInfo hide={hide} darkMode={darkMode}>
                      <AuthInfo rtl={rtl} />
                    </SmallScreenAuthInfo>
                  </div>
                </Col>
              </Row>
            </div>
            <Layout>
              {/* Mobile backdrop overlay */}
              {collapsed && window.innerWidth <= 768 && (
                <div
                  onClick={toggleCollapsedMobile}
                  style={{
                    position: 'fixed', top: 64, left: 0,
                    width: '100vw', height: 'calc(100vh - 64px)',
                    background: 'rgba(0,0,0,0.45)',
                    zIndex: 1049,
                  }}
                />
              )}
              {!topMenu
                // || window.innerWidth <= 991 
                ? (
                  <ThemeProvider theme={darkTheme}>
                    <Sider width={280} style={SideBarStyle} collapsed={!collapsed} theme={darkMode ? 'light' : 'dark'}>
                      {/* <Sider width={280} style={SideBarStyle} collapsed={collapsed} theme={!darkMode ? 'light' : 'dark'}> */}
                      <Scrollbars
                        className="custom-scrollbar"
                        autoHide
                        autoHideTimeout={500}
                        autoHideDuration={200}
                        renderThumbHorizontal={renderThumbHorizontal}
                        renderThumbVertical={renderThumbVertical}
                        renderView={renderView}
                        renderTrackVertical={renderTrackVertical}
                      >
                        {/* Close button - mobile only */}
                        {/* <div className="sidebar-mobile-close" role="button" tabIndex={0}
                          onClick={toggleCollapsedMobile}
                          onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') toggleCollapsedMobile(); }}
                          aria-label="Close sidebar"
                        >
                          <FeatherIcon icon="x" size={20} />
                        </div> */}
                        <p className="sidebar-nav-title">MAIN MENU</p>
                        {/* Blocks clicks on sidebar links the plan does not include */}
                        <div onClickCapture={(e) => blockRestrictedClick(e, plan)}>
                          <MenueItems
                            topMenu={topMenu}
                            rtl={rtl}
                            toggleCollapsed={toggleCollapsedMobile}
                            darkMode={!darkMode}
                          // darkMode={darkMode}
                          />
                        </div>
                      </Scrollbars>
                    </Sider>
                  </ThemeProvider>
                ) : null}
              <Layout className="atbd-main-layout">
                <Content>
                  <WrappedComponent {...this.props} />
                  {/* <Footer className="admin-footer" style={footerStyle}>
                    <Row>
                      <Col md={12} xs={24}>
                        <a href="https://cxsquare.solutions/" className="admin-footer__link" target="_blank" rel="noopener noreferrer">
                          <span className="admin-footer__copyright">Powered by CXSquare Solutions @ {currentYear}</span>
                        </a>
                      </Col>
                    </Row>
                  </Footer> */}
                </Content>
              </Layout>
            </Layout>
          </Layout >
          <div className="floating-actions">
            <div style={{ cursor: "pointer" }} tabIndex={0} role="button"
              onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                  showCustomizer();
                  this.getAllNotes();
                }
              }}
              className="customizer-trigger notes-trigger"
              onClick={() => {
                showCustomizer();
                this.getAllNotes();
              }}
            >
              <NotesIcon />
            </div>
            <div style={{ cursor: "pointer" }} tabIndex={0} role="button"
              onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                  showGenie();
                }
              }}
              className="customizer-trigger1 genie-trigger"
              onClick={() => {
                showGenie();
              }}
            >
              <img src={require('../static/img/defaultImages/Genie.png')} alt="Genie" className="genie-icon" style={{ padding: 2 }} />
            </div>
          </div>
          <div className={`${customizerAction ? 'customizer-wrapper show' : 'customizer-wrapper'}`}>
            <div className="customizer">
              <div className="customizer__head">
                <h4 className="customizer__title">Personal Notes</h4>
                <span className="customizer__sub-title">Leave Your Notes Here...</span>
                <div style={{ cursor: "pointer" }} tabIndex={0} role="button"
                  onKeyDown={(e) => {
                    if (e.key === 'Enter' || e.key === ' ') {
                      showCustomizer();
                    }
                  }}
                  className="customizer-close"
                  onClick={() => {
                    showCustomizer();
                  }}
                >
                  <FeatherIcon icon="x" />
                </div>
              </div>
              <div className="customizer__body">
                <div className="customizer__single">
                  {/* <h4>Layout Type</h4> */}
                  <div style={{ cursor: "pointer", color: '#40a9ff' }} tabIndex={0} role="button"
                    onKeyDown={(e) => {
                      if (e.key === 'Enter' || e.key === ' ') {
                        this.handleNoteClick("Create");
                      }
                    }}
                    className="text_icon"
                    onClick={() => {
                      this.handleNoteClick("Create");
                    }}
                  >
                    <FeatherIcon icon="plus" size={17} className="text_iconspace" /> Notes
                  </div>
                  {confirmPopup && <ConfirmationPopup confirmPopup={confirmPopup} setConfirmPopup={this.onclickDelectclose} GetCallback={this.handleDelete} deleteId={deleteId} page="Notes" />}
                  {notePopup && <NotesPopup setNotePopup={this.closePopup} notePopup={notePopup} popupType={popupType} UrlId={UrlId} AllNotes={this.getAllNotes} noteValue={noteId} page={page} />}
                  <ul className="customizer-list" style={{ marginTop: 10 }}>
                    {notes && notes.map((data) => (
                      <li key={data.note_id} className="customizer-list__item" style={{ width: "100%" }}>
                        <Card className={data.relatedTo}>
                          <Cards headless>
                            <h4>
                              <span style={{ marginTop: 0 }}>
                                {data.note_title}
                                <span className={`status-bullet ${data.relatedTo}`} />
                              </span>
                            </h4>
                            <p >{data.note_desc && data.note_desc !== "" ? <CustomHtmlParser html={data.note_desc} key={data.note_id} page="Previewss" /> : "Note Description"}</p>
                            <div className="actions">
                              <div style={{ display: "flex", gap: 10 }}>
                                <span >
                                  <div
                                    onClick={() => { this.OnClickofDelete(data.note_id) }}
                                    tabIndex={0} role="button" className="fetcherDelete-Icon"
                                    onKeyDown={(e) => {
                                      if (e.key === 'Enter' || e.key === ' ') {
                                        this.OnClickofDelete(data.note_id)
                                      }
                                    }}>
                                    <FeatherIcon icon="trash-2" size={16} />
                                  </div>
                                </span>
                                <span style={{ marginLeft: 10 }}>
                                  <div
                                    onClick={() => { this.handleNoteClick("Update", data.note_id) }}
                                    className='fetcherEdit-Icon' tabIndex={0} role="button"
                                    onKeyDown={(e) => {
                                      if (e.key === 'Enter' || e.key === ' ') {
                                        this.handleNoteClick("Update", data.note_id)
                                      }
                                    }}>
                                    <FeatherIcon icon="edit" size={16} />
                                  </div>
                                </span></div>
                              <div />
                            </div>
                          </Cards>
                        </Card>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <ChatBot />
        </Div >
      );
    }
  }
  const mapStateToProps = (state) => {
    return {
      ChangeLayoutMode: state.ChangeLayoutMode.data,
      rtl: state.ChangeLayoutMode.rtlData,
      topMenu: state.ChangeLayoutMode.topMenu,
      genieChat: state.chatRedux.chatBot,
      storeSubcription: state.localRedux.subcription,
      plan: selectPlan(state),
    };
  };
  const mapDispatchToProps = {
    setChatCall,
  };
  LayoutComponent.propTypes = {
    ChangeLayoutMode: propTypes.bool,
    rtl: propTypes.bool,
    topMenu: propTypes.bool,
    changeRtl: propTypes.func,
    changeLayout: propTypes.func,
    changeMenuMode: propTypes.func,
    genieChat: propTypes.bool,
    storeSubcription: propTypes.object,
    plan: propTypes.object,
    setChatCall: propTypes.func.isRequired,
  };

  return connect(mapStateToProps, mapDispatchToProps)(LayoutComponent);
};
export default ThemeLayout;